import React from "react";
import { Query } from "react-apollo";
import { LIST_LOCATIONS } from "../../../graphql";
import InputSelect from "../../UI/Input/Select";

const Container = ({onChange,...rest}) => (
  <Query query={LIST_LOCATIONS}>
    {({ loading, error, data }) => {
      if (loading) return <p>Loading...</p>;
      if (error) return <p>Error :(</p>;
     const locations = data.listLocations
      return (
        <InputSelect
        options={locations.map(location =>{
          return(
            {text: location.name,value:location.id}
          )
        }
        ).filter(c => c)}
        onChange={value => onChange(value)}
        defaultText="-- Select location --"
        {...rest}
        />
        
      )
    }}
  </Query>
);

export default Container;
